var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useContext, useState } from 'react';
import { CarouselNav } from '../../CarouselNav';
import { Wrapper } from './ui/Layout';
import { useCategories } from './useCategories';
import { Categories } from './Categories';
import { EmblaCarousel } from '../EmblaCarousel';
import { VideoCarouselSlide } from '../EmblaCarousel/VideoSlide';
import { CompactViewContext } from '../Providers/CompactViewProvider';
export const FullWidthVideoCarousel = (_a) => {
    var { videos, useControlNumbers = true, numberOfVideosToShow = 5 } = _a, props = __rest(_a, ["videos", "useControlNumbers", "numberOfVideosToShow"]);
    const { categories } = useCategories(videos);
    const [videoIdx, setVideoIdx] = useState(0);
    const { isCompact } = useContext(CompactViewContext);
    const scrollPrev = useCallback(() => {
        if (isCompact) {
            setVideoIdx((videoIdx - 1 + videos.length) % videos.length);
        }
        else {
            setVideoIdx((videoIdx - 2 + videos.length) % videos.length);
        }
    }, [isCompact, videos.length, videoIdx, setVideoIdx]);
    const scrollNext = useCallback(() => {
        if (isCompact) {
            setVideoIdx((videoIdx + 1) % videos.length);
        }
        else {
            setVideoIdx((videoIdx + 2) % videos.length);
        }
    }, [isCompact, videos.length, videoIdx, setVideoIdx]);
    const onCategoryClick = useCallback((cat) => {
        const number = videos.findIndex(v => v.category === cat);
        setVideoIdx(number);
    }, [videos, setVideoIdx]);
    return (React.createElement(Wrapper, null,
        categories.length > 0 && (React.createElement(Categories, { categories: categories, currentCategory: videos[videoIdx].category, onClick: onCategoryClick })),
        React.createElement(EmblaCarousel, Object.assign({}, props, { slides: videos, numberOfSlidesToShow: numberOfVideosToShow, videoIdx: videoIdx, setVideoIdx: n => {
                setVideoIdx((n + videos.length) % videos.length);
            }, scrollNext: scrollNext, scrollPrev: scrollPrev, renderSlide: ({ vid, idx, affordanceState, hasInteracted }) => (React.createElement(VideoCarouselSlide, { video: vid, affordanceState: affordanceState, isCurrent: idx === videoIdx, hasInteracted: hasInteracted })) })),
        React.createElement(CarouselNav, { handlePrev: () => scrollPrev(), handleNext: () => scrollNext(), allowLooping: true, index: videoIdx + 1, total: videos.length, useControlNumbers: isCompact || useControlNumbers })));
};
//# sourceMappingURL=index.js.map